import PostCreateForm from "./post-create-form";

export default PostCreateForm;